import React from 'react';
import { Globe, Search } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export const SettingsCrm = ({
  crmConfig, setCrmConfig,
  crmTestStatus, testCrmConnection, saveCrmConfig,
  crmTestDni, setCrmTestDni, crmQuerying, queryCrmByDni, crmQueryResult
}) => (
  <div className="space-y-6">
    <Card className="p-6" data-testid="crm-config-card">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-slate-900 flex items-center gap-2" style={{fontFamily: 'Manrope'}}><Globe className="w-5 h-5 text-cyan-600" />Integración CRM Moracero</h3>
          <p className="text-sm text-slate-600">Conecta tu sistema Moracero para consultar casos automáticamente</p>
        </div>
        {crmConfig.url && (
          <Button onClick={testCrmConnection} variant="outline" disabled={crmTestStatus === 'testing'} data-testid="test-crm-btn">
            {crmTestStatus === 'testing' ? 'Probando...' : crmTestStatus === 'success' ? 'Conectado' : 'Probar Conexión'}
          </Button>
        )}
      </div>
      <div className="space-y-4">
        <div><Label>URL Base del CRM</Label><Input value={crmConfig.url} onChange={(e) => setCrmConfig({ ...crmConfig, url: e.target.value })} placeholder="https://mi-empresa.moracero.com.ar" data-testid="crm-url-input" /><p className="text-xs text-slate-500 mt-1">Sin barra final. Ej: https://ostengo-seg.moracero.com.ar</p></div>
        <div><Label>Client ID</Label><Input value={crmConfig.client_id} onChange={(e) => setCrmConfig({ ...crmConfig, client_id: e.target.value })} placeholder="02ac3553b5a5438287a2156d83f0cad1" data-testid="crm-client-id-input" /></div>
        <div className="grid grid-cols-2 gap-4">
          <div><Label>Usuario</Label><Input value={crmConfig.username} onChange={(e) => setCrmConfig({ ...crmConfig, username: e.target.value })} placeholder="ClienteWS" data-testid="crm-username-input" /></div>
          <div><Label>Contraseña</Label><Input type="password" value={crmConfig.password} onChange={(e) => setCrmConfig({ ...crmConfig, password: e.target.value })} placeholder="ClienteWS$2026" data-testid="crm-password-input" /></div>
        </div>
        <Button onClick={saveCrmConfig} className="bg-cyan-600 hover:bg-cyan-700" data-testid="save-crm-btn">Guardar Configuración CRM</Button>
      </div>
    </Card>

    {crmConfig.url && (
      <Card className="p-6" data-testid="crm-query-card">
        <h3 className="text-lg font-semibold text-slate-900 mb-4 flex items-center gap-2" style={{fontFamily: 'Manrope'}}><Search className="w-5 h-5 text-cyan-600" />Consulta de Prueba al CRM</h3>
        <div className="flex gap-2 mb-4">
          <Input value={crmTestDni} onChange={(e) => { if (/^\d*$/.test(e.target.value)) setCrmTestDni(e.target.value); }} placeholder="DNI del cliente" className="flex-1" maxLength={11} data-testid="crm-test-dni-input" />
          <Button onClick={queryCrmByDni} disabled={crmQuerying || !crmTestDni} className="bg-cyan-600 hover:bg-cyan-700" data-testid="crm-query-btn">{crmQuerying ? 'Consultando...' : 'Consultar'}</Button>
        </div>
        {crmQueryResult && (
          <div className="bg-slate-50 rounded-lg p-4 space-y-3" data-testid="crm-query-result">
            <div className="flex justify-between items-center border-b pb-2">
              <span className="font-semibold text-slate-800">{crmQueryResult.client_info?.full_name || 'Sin nombre'}</span>
              <span className="text-lg font-bold text-red-600">${crmQueryResult.total_debt?.toLocaleString('es-AR', {minimumFractionDigits: 2})}</span>
            </div>
            {crmQueryResult.fichas?.map((f, i) => (
              <div key={f.portfolio_group_name || i} className="text-sm bg-white p-3 rounded border">
                <p className="font-medium text-slate-700">{f.portfolio_group_name || f.client_name}</p>
                {f.pago_facil_code && <p className="text-xs text-slate-500">Pago Fácil: {f.pago_facil_code}</p>}
                {f.rapipago_code && <p className="text-xs text-slate-500">Rapipago: {f.rapipago_code}</p>}
              </div>
            ))}
            {crmQueryResult.saldos?.map((s) => (
              <div key={s.balance_number} className="text-sm">
                <p className="font-medium text-slate-700 mb-1">Saldo #{s.balance_number} - {s.date}</p>
                <div className="space-y-1 pl-3 border-l-2 border-cyan-200">
                  {s.installments?.map((c) => (
                    <div key={c.installment_number} className="flex justify-between text-xs bg-white rounded px-2 py-1">
                      <span>Cuota {c.installment_number} - Vto: {c.due_date}</span>
                      <span className="font-semibold text-red-600">${c.amount?.toLocaleString('es-AR', {minimumFractionDigits: 2})}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </Card>
    )}
  </div>
);
